// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__naLdD","left":"StickyBox_left__LGTx3","right":"StickyBox_right__B-v-p"};